import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import {
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Tooltip,
	useTheme,
} from "@mui/material";
import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";

interface DeleteConfirmationProps {
	open?: boolean;
	handleClose?: () => void;
	text?: string;
	handleDeleteFun?: (...args: any[]) => any;
	loading?: boolean;
}

export default function DeleteConfirmation({
	open: propOpen,
	handleClose,
	text = "Are you want delete this service item?",
	handleDeleteFun,
	loading = false,
}: DeleteConfirmationProps) {
	const [internalOpen, setInternalOpen] = useState(false);
	const isControlled = propOpen !== undefined;
	const open = isControlled ? propOpen : internalOpen;
	const theme = useTheme();

	const handleModalClose = () => {
		setInternalOpen(false);
		handleClose?.();
	};

	const handleDelete = async () => {
		try {
			await handleDeleteFun?.();
		} finally {
			handleModalClose();
		}
	};

	return (
		<>
			<Tooltip title="Delete" arrow>
				<IconButton
					onClick={() => setInternalOpen(true)}
					sx={{
						"&:hover": {
							background: theme.colors.error.lighter,
						},
						color: theme.palette.error.main,
					}}
					color="inherit"
					size="small"
				>
					<DeleteTwoToneIcon fontSize="small" />
				</IconButton>
			</Tooltip>
			<ModalsWrapper
				maxWidth="xs"
				showModal={open}
				setShowModal={() => {
					handleModalClose();
				}}
				modalData={{ title: "" }}
			>
				<div>
					<DialogTitle
						id="alert-dialog-title"
						sx={{
							textAlign: "center",
							fontWeight: "bold",
							fontSize: "1.5rem",
							paddingTop: "0px !important",
						}}
					>
						Are you sure?
					</DialogTitle>
					<DialogContent>
						<DialogContentText
							id="alert-dialog-description"
							sx={{
								textAlign: "center",
								color: "text.secondary",
								fontSize: "1rem",
							}}
						>
							{text}
						</DialogContentText>
					</DialogContent>
					<DialogActions sx={{ justifyContent: "center" }}>
						<Button
							onClick={handleModalClose}
							variant="outlined"
							sx={{
								borderColor: "grey.400",
								color: "grey.700",
								"&:hover": { backgroundColor: "grey.100" },
							}}
						>
							Cancel
						</Button>
						<Button
							onClick={handleDelete}
							color="error"
							variant="outlined"
							disabled={loading}
						>
							{loading ? "Deleting..." : "Delete"}
						</Button>
					</DialogActions>
				</div>
			</ModalsWrapper>
		</>
	);
}
